import dayjs from "dayjs";
import Swal from "sweetalert2";
import i18n from '@/i18n';

export const getRoleName = (roleName) => {
    // const roleMapping = {
    //     ROLE_SUPERADMIN: "Super Admin",
    //     ROLE_ADMIN: "Admin",
    //     ROLE_ORGANIZER: "Organizer"
    // };

    // return roleMapping[roleName] || roleName.replace(/^ROLE_/, '');
    return roleName.replace(/^ROLE_/, '');
};

export function formatDate(dateString) {
    if (!dateString) return '-';
    return dayjs(dateString).format("YYYY-MM-DD hh:mm A");
}

export function getUser() {
    const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
    if (!user) {
        console.error("No user found.");
    }

    return user;
}

export function getUserRole() {
    const user = getUser();
    if (!user) {
        console.error("No user found.");
        return null;
    }

    return user.role ? user.role : null;
}

export function setUserRole(newRole) {
    const user = getUser();
    if (!user) {
        console.error("No user found.");
        return false;
    }

    user.role = newRole;
    localStorage.setItem("user", JSON.stringify(user));
}

export function getUserPermission() {
    const permissionList = localStorage.getItem("permissionList") ? JSON.parse(localStorage.getItem("permissionList")) : null;
    if (!permissionList) {
        console.error("No permission list found.");
    }

    return permissionList;
}

export function checkPermission(permissionName) {
    if (!permissionName) return false;

    const permissionList = getUserPermission();
    if (!permissionList) return false;

    const foundPermission = permissionList.find(p => p.name === permissionName);
    if (foundPermission) {
        return foundPermission.hasPermission;
    } else {
        return false;
    }
}

export function showErrorAlert(error, customMsg) {
    let errorMessage = '';

    if (process.env.NODE_ENV === 'production' && !customMsg){
        setTimeout(() => {
            Swal.fire({
                title:  i18n.global.t('attention'),
                icon: "error",
                html: i18n.global.t('error-occurred').replace(/\n/g, '<br>'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: "OK"
            });
        }, 800)
        return;
    }

    if (customMsg) {
        errorMessage = customMsg;
    } else {
        errorMessage = error?.response?.data?.errorMessage?.[0]?.message ?? error?.response?.data?.message ?? 'An error occurred.';
    }
    console.error('Error:', customMsg ?? error);

    setTimeout(() => {
        Swal.fire({
            title: i18n.global.t('attention'),
            icon: "error",
            text: errorMessage || "An error occurred.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "OK"
        });
    }, 800)
}

export async function showNotSupportedImageSizeAlert(width, height, supportedWidth, supportedHeight) {
    await Swal.fire({
        title: "Attention",
        icon: "warning",
        html: i18n.global.t('not-supported-image-size', { width: width, height: height, supportedWidth: supportedWidth, supportedHeight: supportedHeight }).replace(/\n/g, '<br>'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "OK"
    });
}

export async function showNotSupportedImageFileSizeAlert() {
    await Swal.fire({
        title: "Attention",
        icon: "warning",
        text: i18n.global.t('file-size-must-be-less-than-5MB'),
        allowOutsideClick: true,
        allowEscapeKey: false,
        confirmButtonText: "OK"
    });
}

export function showNotSupportedImageFileTypeAlert() {
    Swal.fire({
        title: "Attention",
        icon: "warning",
        text: i18n.global.t('file-type-must-be-webp'),
        allowOutsideClick: true,
        allowEscapeKey: false,
        confirmButtonText: "OK"
    });
}

export function maskNameUntilLastFourWords(fullName) {
  if (!fullName) {
    return '';
  }

  // If the string has 4 or fewer characters, return as is.
  if (fullName.length <= 4) {
    return fullName;
  }

  // Keep last 4 characters
  const lastFour = fullName.slice(-4);

  // Mask all previous characters with '#'
  const masked = '#'.repeat(fullName.length - 4);

  return masked + lastFour;
}